export const BALANCE_LABELS = {
  FERIE: 'Ferie',
  FERIE_CARRIED: 'Overført ferie',
  FERIEFRIDAG: 'Feriefridage',
  FRITVALG: 'Fritvalg',
  AFSPADSERING: 'Afspadsering',
  UDDANNELSE: 'Uddannelse',
  BARN_HOSPITAL: 'Barn på hospital',
  BOERNEOMSORG: 'Børneomsorg',
  BOERNEBOERN: 'Børnebørn',
  NAERSTAENDE: 'Nærtstående',
  NAERSTAENDE_KRITISK: 'Nærtstående (kritisk)',
  BARSEL_FOEDENDE: 'Barsel (fødende)',
  BARSEL_IKKE_FOEDENDE: 'Barsel (ikke-fødende)',
  BARSEL_DELT: 'Delt barsel',
  SENIOR: 'Seniordag',
};

// Maps registration code account_handling values to the balance_code they deduct from
export const ACCOUNT_HANDLING_TO_BALANCE = {
  vacation_out: 'FERIE',
  extra_vacation_out: 'FERIEFRIDAG',
  time_off_out: 'AFSPADSERING',
  fritvalg_out: 'FRITVALG',
};
